import { render, staticRenderFns } from "./FbPicture.vue?vue&type=template&id=b5b766cc"
import script from "./FbPicture.vue?vue&type=script&lang=js"
export * from "./FbPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports